import { Facet, RangeSetBuilder } from "@codemirror/state";
import {
  Decoration,
  DecorationSet,
  EditorView,
  ViewPlugin,
  ViewUpdate,
} from "@codemirror/view";

export type LineRange = { start: number; end: number };

export const facet = Facet.define<LineRange[], LineRange[]>({
  combine: (rangeArrays) => rangeArrays.flat(),
});

const lineRangePattern = /(?<start>\d+)(?:-(?<end>\d+))?,?/g;
export function parse(lineRanges: string): LineRange[] {
  const ranges: LineRange[] = [];
  let matchResult = null;
  while ((matchResult = lineRangePattern.exec(lineRanges)) !== null) {
    if (matchResult.groups?.start === undefined) continue;
    const start = parseInt(matchResult.groups.start, 10);
    const end = matchResult.groups?.end
      ? parseInt(matchResult.groups.end, 10)
      : start;
    ranges.push({ start, end });
  }
  return ranges;
}

const highlight = Decoration.line({
  attributes: { class: "cm-highlightedLine" },
});

export const viewPlugin = ViewPlugin.fromClass(
  class {
    decorations: DecorationSet;

    constructor(view: EditorView) {
      const lineRanges = view.state.facet(facet);
      const builder = new RangeSetBuilder<Decoration>();
      for (const { start, end } of lineRanges) {
        for (let i = start; i <= end; i++) {
          const line = view.state.doc.line(i);
          builder.add(line.from, line.from, highlight);
        }
      }
      this.decorations = builder.finish();
    }

    // No need to update because our editors are read-only.
    update(update: ViewUpdate) {}
  },
  {
    decorations: (v) => v.decorations,
  }
);
